import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React from "react";
import { Colors } from "../../Constants/Colors";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { WebRoutes } from "../../Routes/WebRoutes";
import { useNavigate } from "react-router-dom";
export default function HamburgerButton() {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Box
        sx={{
          background: Colors.appointmentCardBgColor,
          padding: "12px",
          borderRadius: "50%",
          marginRight: "10px",
        }}
      >
        <MenuIcon
          onClick={() => setOpen(true)}
          sx={{
            color: Colors.greenBorderColor,
          }}
        />
      </Box>

      {/* Full-width overlay sliding from the top */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          width: "100%",
          left: 0,
          right: 0,
          maxWidth: "476px",
          mx: "auto",
          background: Colors.appointmentCardBgColor,
          borderRadius: "0px 0px 12px 12px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          zIndex: 9999,
          transition: "height 0.3s ease-in-out",
          height: open ? "210px" : "0px",
          overflow: "hidden",
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={() => setOpen(false)}
          sx={{ position: "absolute", right: 10, top: 10 }}
        >
          <CloseIcon sx={{ color: Colors.greenBorderColor }} />
        </IconButton>

        {/* Menu Items */}
        <List
          sx={{
            marginTop: "40px",
            opacity: open ? 1 : 0,
            transition: "opacity 0.3s ease-in-out",
          }}
        >
          <ListItem>
            <ListItemIcon>
              <img src="/icons/calendar.svg" alt="Appointments" />
            </ListItemIcon>
            <ListItemText
              onClick={() => {
                navigate(WebRoutes.ALL_APPOINTMENTS);
                setOpen(false);
              }}
              className="subtitle-medium"
              primary="My Appointments"
              sx={{
                cursor: "pointer",
              }}
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <img src="/icons/receipt.svg" alt="Queries" />
            </ListItemIcon>
            <ListItemText
              onClick={() => {
                navigate(WebRoutes.QUERIES);
                setOpen(false);
              }}
              className="subtitle-medium"
              sx={{ color: Colors.red, cursor: "pointer" }}
              primary="My Queries"
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <img src="/icons/logout.svg" alt="Logout" />
            </ListItemIcon>
            <ListItemText
              onClick={() => {
                localStorage.clear();
                sessionStorage.clear();
                navigate(WebRoutes.BOOKING_STEP_ONE);
                setOpen(false);
              }}
              className="subtitle-medium"
              sx={{ cursor: "pointer", color: Colors.red }}
              primary="Logout"
            />
          </ListItem>
        </List>
      </Box>
    </>
  );
}
